export const SubscriptionPlans = [
  {
    title: "PRIMARY (COMMON ENTRANCE)",
    color: "#313848",
    monthly: "Monthly - NGN 1000",
    quaterly: "Quarterly - NGN 1,500",
    yearly: "Yearly - NGN 3,500",
    content:
      "This package contains video lessons and CBT practice questions for the primary school level preparing for common entrance exam.",
  },
  {
    title: "JUNIOR (BECE)",
    color: "#6BBB99",
    monthly: "Monthly - NGN 1500",
    quaterly: "Quarterly - NGN 2,500",
    yearly: "Yearly - NGN 5,500",
    content:
      "This package contains video lessons and CBT practice questions for the JUNIOR secondary school level preparing to write the BECE exam.",
  },
  {
    title: "SENIOR (WAEC, NECO, JAMB, SAT)",
    color: "#FAA96A",
    monthly: "Monthly - NGN 2000",
    quaterly: "Quarterly - NGN 3000",
    yearly: "Yearly - NGN 10,500",
    content:
      "This package contains video lessons, WAEC, NECO, JAMB and SAT past questions for the SENIOR secondary school level.",
  },
  {
    title: "FULL SUBSCRIPTION",
    color: "#7C82D8",
    monthly: "Monthly - NGN 2,500",
    quaterly: "Quarterly - NGN 5,500",
    yearly: "Yearly - NGN 15,000",
    content:
      "This package is a combination of all the other packages. Subscribe and you get access to the primary, junior and secondary content.",
  },
];
